export default __webpack_public_path__ + "static/media/step3.30375f02.webp";